import { gql } from "@apollo/client";
import { dateFormat } from "./helper";

export const typeDef = gql`
  type VoucherCode {
    id: ID
    code: String
    voucherId: Int
    validityStartAt: String
    validityEndAt: String
    expire_at: String
    isAvailable: Boolean
    voucher: Voucher
  }

  type Voucher {
    id: ID
    name: String
    description: String
    discountPrice: Int
    limitPrice: Int
    trialExtendTerm: Int
    trialExtendTermUnit: String
    trialExtendEndOf: String
    validityStartAt: String
    validityEndAt: String
  }
`;
export const resolvers = {
  VoucherCode: {
    id: (v) => v.voucher_code_id,
    voucherId: (v) => v.voucher_id,
    isAvailable: (v) => v.is_available,
    validityStartAt: (v) => dateFormat(v.validity_start_at),
    validityEndAt: (v) => dateFormat(v.validity_end_at),
  },
  Voucher: {
    id: (v) => v.voucher_id,
    discountPrice: (v) => v.discount_price,
    limitPrice: (v) => v.limit_price,
    trialExtendTerm: (v) => v.trial_extend_term,
    trialExtendTermUnit: (v) => {
      return v?.trial_extend_term_unit?.split("_").slice(-1)[0];
    },
    trialExtendEndOf: (v) => {
      return v?.trial_extend_end_of?.split("_").slice(-1)[0];
    },
    validityStartAt: (v) => dateFormat(v.validity_start_at),
    validityEndAt: (v) => dateFormat(v.validity_end_at),
  },
};
